import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import Text from 'components/Text/Text';
import { Badge } from 'components/Badge';
import style from './Modifier.module.scss';

interface IProps {
	onDelete: (id: string) => void;
	positionNumber: number;
	label: string;
	modifierId: string;
	isDefault: boolean;
}

export const Modifier: React.FC<IProps> = React.memo(({ onDelete, positionNumber, label, modifierId, isDefault }) => {
	const handleRemove = () => {
		onDelete(modifierId);
	};

	return (
		<div className={style.container}>
			<div className={style.content}>
				<div className={style.header}>
					<div className={style.labelRow}>
						<Text
							className={style.positionNumber}
							translationNameSpace="form"
							translationKey="positionNumberLabel"
							translationOptions={{ positionNumber }}
							theme="secondary"
							size="s"
							weight="bold"
						/>
						<Text
							className={style.labelText}
							translationKey={label}
							theme="secondary"
							size="xs"
							withTooltip={true}
						/>
						<div />
					</div>
					<div className={style.itemAdditionalInfoDeleteBtnWrapper}>
						{isDefault && (
							<Badge color="green">
								<Text translationNameSpace="form" translationKey="isDefaultLabel" asFragment={true} />
							</Badge>
						)}
						<div
							className={style.deleteBtn}
							onClick={handleRemove}
							data-testid={`removeModifier-${modifierId}`}>
							<svg className={style.icon}>
								<use xlinkHref={`${breadcrumbs}#bin`} />
							</svg>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});
